

export const updateFeatureImage = (draft, action) => {
    const { url } = action;
    
    draft.experience.featured_image = url;

    return draft;
};